import * as React from "react"

import { NavMain } from "@/components/nav-main"
import { NavSecondary } from "@/components/nav-secondary"
import { NavUser } from "@/components/nav-user"
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from "@/components/ui/sidebar"
import useGcpsUIController from "@/hooks/useGlobalContext"
import pageRoutes from "@/app/routes/route"
import { BookSearch, BookUser, GraduationCap, Layers2, MonitorPlayIcon } from "lucide-react"
import { useTheme } from "@/hooks/useTheme"
import { withPrefix } from "@/lib/utils"

const data = {
	navSecondary: [
		{
			title: "Student Email",
			url: "https://login.microsoftonline.com",
			icon: GraduationCap,
		},
		{
			title: "Virtual Lectures",
			url: "https://lms.gcps.edu.gh/",
			icon: MonitorPlayIcon,
		},
		{
			title: "E-Port",
			url: "https://eport.nantisys.com/",
			icon: Layers2,
		},
		{
			title: "E-Library",
			url: "http://elibrary.gcps.edu.gh/",
			icon: BookUser,
		},
		{
			title: "GCPS Repository",
			url: "https://repository.gcps.edu.gh/",
			icon: BookSearch,
		},
		{
			title: "Post Graduate Journal",
			url: "https://journal.gcps.edu.gh/",
			icon: BookSearch,
		},
	],
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
	const { controller } = useGcpsUIController();
	const { resident } = controller;
	const { theme } = useTheme();
	const [logoType, setLogoType] = React.useState(theme);

	React.useEffect(() => {
		if (theme === "system") {
			const systemTheme = window.matchMedia("(prefers-color-scheme: dark)")
				.matches
				? "dark"
				: "light";
			setLogoType(systemTheme)
			return;
		}

		setLogoType(theme)
	}, [theme]);

	return (
		<Sidebar collapsible="offcanvas" {...props}>
			<SidebarHeader>
				<SidebarMenu>
					<SidebarMenuItem>
						<SidebarMenuButton
							asChild
							className="data-[slot=sidebar-menu-button]:py-14.5!"
						>
							<a href="#">
								<img
									src={logoType === 'dark' ? withPrefix("assets/images/logo-ris-dark.png") : withPrefix("/assets/images/logo-ris.png")}
									alt="Knust Resident Portal Logo"
								/>
							</a>
						</SidebarMenuButton>
					</SidebarMenuItem>
				</SidebarMenu>
			</SidebarHeader>
			<SidebarContent>
				<NavMain items={pageRoutes} />
				{/* <NavDocuments items={data.documents} />*/}
				<NavSecondary items={data.navSecondary} className="mt-auto" />
			</SidebarContent>
			<SidebarFooter>
				<NavUser user={{
					first_name: resident?.first_name || "Guest",
					last_name: resident?.last_name || "User",
					email: resident?.email || "guest@user.com"
				}} />
			</SidebarFooter>
		</Sidebar>
	)
}
